import * as React from "react";
import * as queryString from "query-string";
import { track } from "../../../analytics";
import styled from "../../../styled-components";
import SignUpForm from "./SignUpForm";
import IndexFooter from "../../Index/IndexFooter";
import SayAppIcon from "../../Index/SayAppIcon";
import AcornsLogo from "../AcornsLogo";
import SayLogo from "../../Index/SayLogo";
import AcornsHeader from "../AcornsHeader/AcornsHeader";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { AppContainer } from "../../../containers/App.container";
import { Subscribe } from "unstated";
import { media } from "../../../breakpoints";
import Footer from "../../../components/Footer/Footer";
import { theme } from "../../../App";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  position: relative;
`;

const SubWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  position: relative;
`;

const Overlay = styled.div`
  background: ${props => props.theme.colors.trueblack};
  position: fixed;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  top: 0;
  left: 0;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  margin: 0 50px 60px 150px;
  max-width: 470px;

  ${media.TABLET`
    align-items: center;
    margin: 0 auto;
    padding: 100px 20px 0;
  `};
`;

const Header = styled.div`
  display: flex;
  margin-left: -9px;

  ${media.TABLET`
    align-items: center;
    flex-direction: column;
    margin-left: 0;
  `};
`;

const SayAppIconWrapper = styled.div`
  height: 87px;
  margin-top: -7px;
  width: 85px;

  ${media.TABLET`
    transform: scale(0.9);
  `};
`;

const Heading = styled.h1`
  color: ${props => props.theme.colors.white};
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.3px;
  line-height: 1.1;
  margin: 0 0 0 20px;

  ${media.TABLET`
    font-size: 32px;
    margin: 20px 0 0 0;
    text-align: center;
  `};
`;

const FooterLogoContainer = styled.div`
  display: flex;
  width: 210px;
  justify-content: space-around;

  @media (max-width: 53.3125em) and (min-width: 48em) {
    width: 120px;
  }

  ${media.TABLET`
    height: 30px;
    margin-top: 60px;
    margin-bottom: 10px;
  `};
`;

const BrokerLogoContainer = styled.div`
  padding-right: 25px;
  border-right: 1px solid ${props => props.theme.colors.white};

  @media (max-width: 53.3125em) and (min-width: 48em) {
    padding-right: 15px;
    margin-right: 15px;
  }
`;

const SayLogoContainer = styled.div`
  margin-top: 3px;
`;

interface IAcornsIndexProps extends RouteComponentProps<{}> {
  context: AppContainer;
}

class AcornsIndex extends React.Component<IAcornsIndexProps> {
  constructor(props: IAcornsIndexProps) {
    super(props);

    this.handlePressLinkClick = this.handlePressLinkClick.bind(this);
  }

  public componentDidMount() {
    if (
      !this.props.context.state.mailingsEmail &&
      queryString.parse(this.props.history.location.search).email
    ) {
      const email = queryString.parse(this.props.history.location.search).email;
      if (email) {
        this.props.context.setMailingsEmail(email[0]);
      }
    }
  }

  public handlePressLinkClick = (publisher: string) => {
    track("Press Article Clicked", { publisher });
  };

  public render() {
    const footerLogoAsProp: JSX.Element = (
      <FooterLogoContainer>
        <BrokerLogoContainer>
          <a href="https://www.acorns.com/" target="_blank">
            <AcornsLogo />
          </a>
        </BrokerLogoContainer>
        <SayLogoContainer>
          <SayLogo />
        </SayLogoContainer>
      </FooterLogoContainer>
    );
    return (
      <>
        <Overlay />
        <Wrapper>
          <SubWrapper>
            <AcornsHeader />
            <Content>
              <Header>
                <SayAppIconWrapper>
                  <SayAppIcon fill="#4BC459" />
                </SayAppIconWrapper>

                <Heading>
                  If you invest,
                  <br /> then you have a vote.
                </Heading>
              </Header>

              <SignUpForm email={this.props.context.state.mailingsEmail} />
            </Content>
            <IndexFooter footerLogoAsProp={footerLogoAsProp} />
          </SubWrapper>

          <Footer
            backgroundColor={theme.colors.acornsGreen}
            hideFormOnMobile={true}
          />
        </Wrapper>
      </>
    );
  }
}

export default withRouter(props => (
  <Subscribe to={[AppContainer]}>
    {(app: AppContainer) => <AcornsIndex {...props} context={app} />}
  </Subscribe>
));



// WEBPACK FOOTER //
// ./src/pages/Acorns/AcornsIndex/AcornsIndex.tsx